import React from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { notifyError, notifySuccess } from "../../../helpers/Notify";
import { useNavigate } from "react-router-dom";

export default function EditService({updatedData,id,name,data,title,refetch,isLoading}) {
    const validateSchema = yup.object().shape({
      name: yup.string().required(`${name} is required`),
    });

  const navigate=useNavigate()
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const result = await updatedData({id,values});
      console.log("Results", result);
      refetch();
      notifySuccess(result?.data?.message || "updated successfully");
        resetForm(); // Reset form values after successful submission
        navigate(`/admin/${name}`)
    } catch (error) {
      console.log(error);
      notifyError(error.message);
    } finally {
      setSubmitting(false);
    }
  };


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title"> {title}</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <div className="row">
                  <div className="col-md-6">
                    <Formik
                      initialValues={{ name:data?.name || "" }}
                      enableReinitialize={true}
                      validationSchema={validateSchema}
                      onSubmit={handleSubmit}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className={`form-group mb-3`}>
                            <label className="text-label">Edit {title}</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder={`Enter ${title}`}
                              name="name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.name}
                            />
                              {/* disabled={
                                !userInfo?.Role?.permissions?.includes(
                                  "amenities/edit"
                                )
                              } */}
                            <div
                              id="val-username1-error"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            >
                              {errors.name && errors.name}
                            </div>
                          </div>
                          <div className="text-right">
                          <button
                            type="submit"
                            className="btn btn-primary me-2"
                            disabled={isLoading}
                          >
                            {isLoading ? (
                              <>
                                <div
                                  className="spinner-border text-light"
                                  role="status"
                                ></div>
                              </>
                            ) : (
                              "Update"
                            )}
                          </button>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
